import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "redux/store";
import env from "env";

import type { InitiateDisbursementRequest, InitiateDisbursementResponse } from "./types";
import { getDisbursementErrorMessage } from "./utils";

const { disburseService } = env.api.baseUrl;

// Use real API
const baseQuery = fetchBaseQuery({
  baseUrl: disburseService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const disbursementApi = createApi({
  reducerPath: "disbursementApi",
  baseQuery,
  tagTypes: ["Disbursement"],
  endpoints: (builder) => ({
    initiateDisbursement: builder.mutation<
      InitiateDisbursementResponse,
      InitiateDisbursementRequest
    >({
      query: (data) => ({
        url: "initiate",
        method: "POST",
        body: data,
      }),
      transformErrorResponse: (response, _meta, arg) => {
        const fileName = arg.file_name;
        return getDisbursementErrorMessage(response, fileName);
      },
      invalidatesTags: ["Disbursement"],
    }),
  }),
});

export const { useInitiateDisbursementMutation } = disbursementApi;
